"use client"

import { motion } from "framer-motion"
import { X, AlertTriangle } from "lucide-react"
import { PORTAL_URL } from "../../config"
import Button from "./Button"


const TokenAlertModal = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  if (!isOpen) return null

  const handleUpgrade = () => {
    window.open(`${PORTAL_URL}`, "_blank")
  }

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex justify-center items-center z-50 fade-in p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="bg-black/80 backdrop-blur-md p-5 sm:p-8 rounded-2xl max-w-md w-full shadow-2xl border border-white/20"
      >
        <div className="flex justify-between items-start mb-5">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center mr-3">
              <AlertTriangle className="w-5 h-5 text-amber-400" />
            </div>
            <h3 className="text-xl font-bold text-white">{title || "Alert"}</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-white/10 text-white/70 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-6">
          <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-3 text-sm text-amber-200">
            <p className="mb-4 text-white/90 text-base">{message}</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Button type="secondary" name="Close" onClick={onClose} className="flex-1" />
            <Button
              type="primary"
              name="Upgrade"
              onClick={handleUpgrade}
              className="flex-1"
            />
        </div>
      </motion.div>
    </div>
  )
}

export default TokenAlertModal
